<template lang="pug">
  .page.profile-page.admin-page
    header.page__header.profile-page__header
      main-header

    .profile-page__notification
      //- admin-notification

    .profile-page__container
      aside.profile-page__aside.md
        side-nav(
        :sideNavData="sideNavData"
        )
      main.profile-page__main.md
        router-view

    footer.page__footer
      main-footer
</template>

<script>
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import SideNav from "../../components/side-nav/side-nav.vue";
import AdminContextRequests from "./components/admin-contests-requests/admin-contests-requests.vue";
import AdminQuotaRequests from "./components/admin-quota-requests/admin-quota-requests.vue";
import AdminNotification from "./components/components/admin-notification.vue";
export default {
  name: "AdminPage",
  components: {
    AdminNotification,
    AdminContextRequests,
    AdminQuotaRequests,
    SideNav,
    MainFooter,
    MainHeader,
  },
  data() {
    return {
      sideNavData: [
        {
          path: "/administrator/requests",
          text: "Все заявки",
        },
        {
          path: "/administrator/contests-requests",
          text: "Заявки по конкурсам от Министерств",
        },
        {
          path: "/administrator/quota-requests",
          text: 'Заявки по квоте "Общереспубликанские"',
        },
        {
          path: "/administrator/managers",
          text: "Контент-менеджеры",
        },
        {
          path: "/administrator/operators",
          text: "Операторы",
        },
        {
          path: "/administrator/place",
          text: "Места",
        },
        {
          path: "/administrator/registry",
          text: "Отчеты",
        },
      ],
    };
  },
};
</script>
